import { LoaderCircle, RefreshCw } from "lucide-react";

export function LoadingScreen() {
  return (
    <div className="center-state" role="status">
      <LoaderCircle className="spin" size={28} />
      <p>正在准备作业管家…</p>
    </div>
  );
}

export function ErrorScreen({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="center-state" role="alert">
      <div className="state-mark error">!</div>
      <h1>暂时无法加载</h1>
      <p>{message}</p>
      <button className="secondary-button" type="button" onClick={onRetry}>
        <RefreshCw size={18} /> 重新加载
      </button>
    </div>
  );
}
